<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import isIphoneX from './utils/index.js'
  import('./assets/js/jweixin-1.3.2')
  export default {
    name: 'app',
    data () {
      return {}
    },
    created () {
      if (window.__wxjs_environment !== undefined && window.__wxjs_environment === 'miniprogram') {
        let isx = isIphoneX()
        this.$store.commit('setSystemStatus', isx)
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    background: #f7f7fa;
  }

  * {
    margin: 0;
    padding: 0;
  }

  html {
    height: 100%;
    overflow: hidden;
  }

  body {
    height: auto;
    background-color: #ecf0f3;
  }
  .icon {
    width: .56rem;
    height: .51rem;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
  .icon-excel {
    color: #36AB60;
  }

  .icon-pdf {
    color: #E0620D;
  }

  .icon-word {
    color: #2985FD;
  }

  .icon-txt {
    color: #17ABE3;
  }

  .icon-html {
    color: #EFC96D;
  }

  .icon-pic {
    color: #3EA362;
  }

  .icon-muisc {
    color: #EA5986;
  }

  .icon-dir {
    color: #FED531;
  }
  .icon-shareDir{
    color: #47a3fb;
  }
  .icon-package {
    vertical-align: .1rem;
  }
  .icon-xinjianwenjianjia,.icon-shangchuanwenjian{
    font-size: .6rem;
    display: block;
    color: #E4393C;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue